// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "vendor" + "_" + "fd7b336ff220335902c2" + ".css";
};